import { unref, readonly, watch } from 'vue';
import { useProductData } from '@composables/useProductData';
import { useBrand } from '@composables/useBrand';
import usePriceLatchkey from './usePriceLatchkey';
import useSizeLatchkey from './useSizeLatchkey';
import useColorLatchkey from './useColorLatchkey';
import LatchkeyParser from '../parsers/ConsolidatedLatchkeyParser';
import useUpcLatchkey from './useUpcLatchkey';
import useImageLatchkey from './useImageLatchkey';
import useLatchkey from './useLatchkey';

// Currently only supports 1 latchkey product per page. TODO fix if needed
// TODO optimize so doesn't recalculate on each instance
/**
 * @param {import('@vueuse/core').MaybeRef<string>} id
 */
function useConsolidatedLatchkey(id) {
  const product = useProductData(unref(id));

  const parsed = LatchkeyParser(unref(product));
  const { latchKeyProductIdsByGroup, selectedLatchkey } = useLatchkey();

  const {
    sizeProps, selectedSizeId, selectedSize, sizes,
  } = useSizeLatchkey(unref(id), readonly(selectedLatchkey), parsed);
  const {
    colorProps, selectedColorId, selectedColor, colors,
  } = useColorLatchkey(unref(id), readonly(selectedLatchkey), parsed);
  const upcData = useUpcLatchkey(unref(id), readonly(selectedLatchkey), parsed);

  const images = useImageLatchkey(product, selectedColor, upcData.selectedUpcId, selectedLatchkey, latchKeyProductIdsByGroup);

  const selectedPrice = usePriceLatchkey(
    {
      id,
      product,
      ...parsed,
      selectedLatchkey: readonly(selectedLatchkey),
      selectedUpcId: upcData.selectedUpcId,
      selectedColor,
      selectedSize,
    },
  );

  // TODO remove once mcom xapi is migrated to use same structure as bcom
  const { isMcom } = useBrand();
  if (isMcom) {
    watch(selectedSize, (size) => {
      selectedColorId.value = Object.keys(size?.colorToSizes)[0];
    });
  }

  return {
    colors,
    sizes,
    selectedColor,
    selectedSize,
    selectedSizeId,
    selectedColorId,
    selectedPrice,
    selectedLatchkey,
    colorProps,
    sizeProps,
    upcData,
    images,
  };
}

export default useConsolidatedLatchkey;
